module.exports = __webpack_public_path__ + "img/concertina.fdf1123e.png";